<template>
  <div id="chart" class="mt-3">
    <apexchart id="chart-domain" type="line" height="400" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";
import moment from "moment";
import 'moment/locale/th'; // ✅ ให้ moment ใช้ภาษาไทย

export default {
  name: "App",
  components: {
    apexchart: VueApexCharts,
  },
  watch: {
    getArrDate: function () {
      const e = moment(new Date()).format('YYYY-MM-DD'); // ✅ กันปัญหา timezone
      if (
        this.getSdateDm.slice(0, 10) == e &&
        this.getEdateDm.slice(0, 10) == e
      ) {
        this.startChart();
      } else {
        this.updateChart();
      }
      this.val = 0;
    },
  },
  data() {
    return {
      colorp: [],
      val: 0,
      range: "",
      series: [],
      chartOptions: {
        chart: {
          type: "line",
          fontFamily: "Prompt, FontAwesome, sans-serif",
        },
        dataLabels: {
          enabled: true,
        },
        series: [],
        title: {
          text: "จำนวนโพสต์ในแต่ละวัน",
        },
        noData: {
          text: "Loading...",
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "getClickDomain",
      "getSdateDm",
      "getEdateDm",
      "getArrDate",
      "getNamePlatform",
      "getDomainArr",
    ]),
    getSeries: function () {
      return [
        {
          name: "จำนวนโพสต์",
          data: [],
        },
      ];
    },
  },
  methods: {
    formatDateTH(dateStr) {
      const m = moment(dateStr).locale('th');
      const buddhistYear = m.year() + 543;       // ปี พ.ศ. เต็ม เช่น 2568
      const buddhistYearShort = buddhistYear % 100; // 68

      return m.format('D MMM ') + buddhistYearShort;
    },

    async updateChart() {
      this.series = [];
      let sdate = "", edate = "";
      if (this.getSdateDm || this.getEdateDm) {
        sdate = "&start=" + this.getSdateDm;
        edate = "&end=" + this.getEdateDm;
      }

      const config = {
        method: "get",
        url:
          "https://api2.cognizata.com/api/v2/userposts/getChartDataPlatform?source=" +
          this.getNamePlatform +
          sdate +
          edate,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      };

      await this.axios(config).then((response) => {
        const _this = this;

        // ✅ สร้างช่วงวันด้วยคีย์แบบ YYYY-MM-DD เสถียรกว่า slice(0,10)
        const getDaysArray = function (s, e) {
          for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
            a.push({
              date: moment(d).format('YYYY-MM-DD'), // ✅
              count: _this.val,
            });
          }
          return a;
        };

        const daylist = getDaysArray(
          new Date(this.getSdateDm),
          new Date(this.getEdateDm)
        );

        const data = response.data;
        const array3 = [...daylist, ...data];
        console.log("res ==== ",data);
        // รวมและ dedupe ตาม key = date
        const distinctItems = [
          ...new Map(array3.map((item) => [item["date"], item])).values(),
        ]
          .sort((a, b) => a.date.localeCompare(b.date)); // ✅ เผื่อคิวเรียงวัน

        const datelist = distinctItems.map((item) => item.date);     // YYYY-MM-DD (ภายใน)
        const datelistTH = datelist.map(d => this.formatDateTH(d));  // ✅ สำหรับแสดงผล
        const countlist = distinctItems.map((item) => item.count);

        // ✅ แสดงช่วงวันที่เป็นไทย
        this.range = `${datelistTH[0]} - ${datelistTH[datelistTH.length - 1]}`;

        this.series = [
          { name: "จำนวนโพสต์", data: countlist },
        ];

        this.chartOptions = {
          title: {
            text: "จำนวนโพสต์ วันที่ " + this.range, // ✅ ไทยแล้ว
            align: "left",
            fontFamily: "Prompt",
          },
          xaxis: {
            categories: datelistTH, // ✅ ใช้วันที่ไทยบนแกน X
          },
        };
      });
    },

    async startChart() {
      const currentTime = new Date();
      currentTime.setDate(currentTime.getDate() - 14);
      try {
        const config = {
          method: "get",
          url:
            "https://api2.cognizata.com/api/v2/userposts/getChartDataPlatform?source=" +
            this.getNamePlatform,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        };

        await this.axios(config).then((response) => {
          const _this = this;

          const getDaysArrays = function (s, e) {
            for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
              a.push({
                date: moment(d).format('YYYY-MM-DD'), // ✅ ใช้ฟอร์แมตคงที่
                count: _this.val,
              });
            }
            return a;
          };

          const de = moment(new Date()).format('YYYY-MM-DD');       // ✅
          const ds = moment(currentTime).format('YYYY-MM-DD');      // ✅
          const daylist = getDaysArrays(new Date(ds), new Date(de));

          const data = response.data;
          const array3 = [...daylist, ...data];

          const distinctItems = [
            ...new Map(array3.map((item) => [item["date"], item])).values(),
          ]
            .sort((a, b) => a.date.localeCompare(b.date)); // ✅ เผื่อคิวเรียงวัน

          const datelist = distinctItems.map((item) => item.date);
          const datelistTH = datelist.map(d => this.formatDateTH(d)); // ✅
          const countlist = distinctItems.map((item) => item.count);

          // ✅ แสดงช่วงวันที่เป็นไทย
          this.range = `${datelistTH[0]} - ${datelistTH[datelistTH.length - 1]}`;

          this.series = [
            { name: "จำนวนโพสต์", data: countlist },
          ];

          if (this.getNamePlatform == "twitter") {
            this.colorp = ["#919495"];
          } else if (this.getNamePlatform == "facebook") {
            this.colorp = ["#4c77bb"];
          } else if (this.getNamePlatform == "pantip") {
            this.colorp = ["#532d84"];
          } else if (this.getNamePlatform == "youtube") {
            this.colorp = ["#e24246"];
          } else if (this.getNamePlatform == "news") {
            this.colorp = ["#fdd072"];
          } else if (this.getNamePlatform == "instagram") {
            this.colorp = ["#ff9773"];
          } else if (this.getNamePlatform == "blockdit") {
            this.colorp = ["#396eb6"];
          } else if (this.getNamePlatform == "threads") {
            this.colorp = ["#e75aa1"];
          } else if (this.getNamePlatform == "telegram") {
               this.colorp = ["#3bced5"];
          } else {
            this.colorp = ["#1f0043"];
          }

          this.chartOptions = {
            yaxis: {
              labels: {
                formatter: (value) => {
                  return value.toLocaleString();
                },
              },
            },
            chart: {
              fontFamily: "Prompt, FontAwesome, sans-serif",
              type: "line",
              zoom: { enabled: true },
              dropShadow: {
                enabled: true,
                color: "#000",
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2,
              },
            },
            colors: this.colorp,
            dataLabels: {
              enabled: true,
              style: { colors: ["#4c412b"] },
              formatter: (value) => value.toLocaleString(),
            },
            stroke: { curve: "smooth" },
            title: {
              text: "จำนวนโพสต์ วันที่ " + this.range, // ✅ ไทยแล้ว
              align: "left",
              fontFamily: "Prompt",
            },
            markers: { size: 1 },
            grid: {
              row: { colors: ["#ffffff", "transparent"], opacity: 0.5 },
              padding: { left: 30 },
            },
            xaxis: {
              categories: datelistTH, // ✅ ใช้วันที่ไทยบนแกน X
            },
          };
        });
      } catch (error) {
        console.error("Error fetching chart data:", error);
        // this.$toast.error("ไม่สามารถดึงข้อมูลกราฟได้ในขณะนี้ กรุณาลองใหม่ภายหลัง");
      }
    },
  },
  created: async function () {
    this.startChart();
  },
};
</script>
